/* In-stock / out-of-stock badge — added by Claude for dxbanimal (draft theme only).
   Reads per-variant availability from the JSON emitted by snippets/stock-badge.liquid,
   injects a badge into the product buy box, and keeps it in sync with variant selection
   (the theme fires a change on #product-selectors and the swatch radios). */
(function(){
  'use strict';
  var dataEl = document.querySelector('[data-stock-badge-data]');
  if(!dataEl) return;
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch(e){ return; }

  var shop = document.querySelector('.product-default .product-shop') || document.querySelector('.product-shop');
  if(!shop) return;
  if(shop.querySelector('.stock-badge')) return;

  var badge = document.createElement('div');
  badge.className = 'stock-badge';
  badge.setAttribute('aria-live','polite');
  var dot = document.createElement('span'); dot.className = 'stock-badge__dot';
  var text = document.createElement('span'); text.className = 'stock-badge__text';
  badge.appendChild(dot); badge.appendChild(text);

  var anchor = shop.querySelector('.prices');
  if(anchor){ anchor.parentNode.insertBefore(badge, anchor); }
  else {
    var title = shop.querySelector('.product-title');
    if(title){ title.parentNode.insertBefore(badge, title.nextSibling); }
    else { shop.insertBefore(badge, shop.firstChild); }
  }

  function currentVariantId(){
    var sel = document.querySelector('#product-selectors');
    if(sel && sel.value) return String(sel.value);
    var form = document.querySelector('#add-to-cart-form');
    if(form){ var idf = form.querySelector('[name="id"]'); if(idf && idf.value) return String(idf.value); }
    return null;
  }
  function isAvailable(){
    var id = currentVariantId();
    if(id !== null && Object.prototype.hasOwnProperty.call(data.variants, id)){
      return !!data.variants[id];
    }
    return !!data.productAvailable;
  }
  function render(){
    var avail = isAvailable();
    badge.classList.toggle('is-in', avail);
    badge.classList.toggle('is-out', !avail);
    text.textContent = avail ? data.labels.in : data.labels.out;
  }
  render();

  var sel = document.querySelector('#product-selectors');
  if(sel){ sel.addEventListener('change', render); }
  var form = document.querySelector('#add-to-cart-form');
  if(form){ form.addEventListener('change', render); }
  // Ella swaps variants asynchronously via option_selection.js; catch late updates too.
  document.addEventListener('click', function(e){
    if(e.target.closest('#add-to-cart-form .swatch, #add-to-cart-form .selector-wrapper')){ setTimeout(render, 60); }
  });
})();
